import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"
import BackgroundImage from "gatsby-background-image"

import { pageHeader } from "./masthead.module.css"

const Masthead = ({ title, subtitle }) => {
  const { placeholderImage } = useStaticQuery(
    graphql`
      query {
        placeholderImage: file(relativePath: { eq: "backgrounds/background-1.png" }) {
          childImageSharp {
            gatsbyImageData(width: 2560, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
          }
        }
      }
    `
  )

  const image = getImage(placeholderImage)
  const bgImage = convertToBgImage(image)

  return (
    <BackgroundImage
      Tag="header"
      className={pageHeader}
      {...bgImage}
      preserveStackingContext
      backgroundColor={`#040e18`}
    >
      <div className="wrapper">
        <h1>{title}</h1>
        {subtitle && <p className="h3">{subtitle}</p>}
      </div>
    </BackgroundImage>
  )
}

export default Masthead
